import { Typography, TextField, Grid } from "@mui/material";
import Button from "../common/Button";
import React, { useState, useEffect } from "react";
import "./TCAdmin.scss";
import { Stack } from "@mui/system";
import { Box, Switch } from "@mui/material";
import SearchBar from "../common/searchBar";
import DateRangePicker from "../TP_DateRangePicker";
import Dropdown from "../../components/TP_Dropdown";
import TCCardView from "./TCCardView";
import TCList from "./TCList";
import { styled } from "@mui/material/styles";
import InstructorDetails from "../Instructor/InstructorDetails";
import axios from "../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { API, FOMRS, APP_ROUTES } from "../../globals/constants";
import ToggleButton from "../ToggleButton";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../loader";
import {
  setcheckedList,
  setemptyDeleteList,
  setemptycheckedList,
} from "../../redux/features/trainingCenterAdmin";
import CsvDownloader from "react-csv-downloader";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import SubHeading from "../common/SubHeading";
import Pagination from "@mui/material/Pagination";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import DeleteAlert from "../DeleteAlert/DeleteModal";
import SingleDelete from "../SingleDeleteAlert/SingleDelete";
import Cookies from "universal-cookie";
import moment from "moment";

const TCAdmin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [pageCount, setPageCount] = useState();
  const [allTC, setAllTC] = useState([]);

  const [checked, setChecked] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [apiResponse, setApiResponse] = useState([]);
  const [exportapiResponse, setexportApiResponse] = useState([]);
  const [loading, setloading] = useState(true);
  const [flag, setFlag] = useState(true);
  const [loadApi, setloadApi] = useState(false);
  const limit = 12;
  const [showModal, setShowModal] = useState(false);
  const [showSingleModal, setShowSingleModal] = useState(false);
  const [singleDeleteId, setSingleDeleteId] = useState();
  let currentDate = new Date();

  let previousDate = new Date();
  let lastday = previousDate.setDate(previousDate.getDate() - 7);
  const [queryParamas, setqueryParamas] = useState({
    limit: limit || 10,
    offset: 0,
    is_active: true,
    // from_date: moment(previousDate).format('YYYY-MM-DD'),
    // end_date: moment(currentDate).format('YYYY-MM-DD'),
  });
  const cookies = new Cookies();
  const loginData = cookies.get("loginData");
  let userID = loginData?.id;
  let userRole = loginData?.role_code;

  const switchHandler = (event) => {
    setChecked(event.target.checked);
  };

  const [allInst, setAllInst] = useState([]);

  const getAllInst = async () => {
    const response = await axios(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
        API.END_POINTS.INSTRUCTOR_ENDPOINT,
      {},
      {},
      {}
    ).then((response) => {
      console.log("allInst", response?.data?.allIns);
      setAllInst(response?.data?.allIns);
    });
  };

  let tcAdminDetail = useSelector((state) => state.tcAdminDetail?.showdetails);

  let multipleDelete = useSelector((state) => state.tcAdminDetail?.deleteList);

  let multipleChecked = useSelector(
    (state) => state.tcAdminDetail?.checkedList
  );

  let instructor = allInst?.map((value) => ({
    id: value?.id,
    value: value?.name,
    label: value?.name,
  }));

  let uniqueInstructor = [
    ...new Map(instructor?.map((item) => [item["value"], item])).values(),
  ];

  const dropdownSelect = async (getName) => {
    console.log("selectLocation", getName);
    console.log("trainingCenter", getName);
    let params = queryParamas;
    getName?.id
      ? (params.studio_id = `${getName?.id}`)
      : delete params.studio_id;
    console.log("params", params);
    setqueryParamas({ ...params });
    // if (getName.id) {
    // 	const response = await axios(
    // 		'GET',
    // 		CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
    // 			API.END_POINTS.TCADMIN_ENDPOINT +
    // 			`?` +
    // 			`studio_id=${getName.id}`,
    // 		{},
    // 		{},
    // 		{}
    // 	).then((response) => {
    // 		// console.log('TrainingCenter', response?.data?.data?.rows);
    // 		setApiResponse(response?.data?.data?.rows);
    // 		setloading(false);
    // 		return response.data;
    // 	});
    // }
  };

  const InstructordropdownSelect = async (getName) => {
    console.log("selectLocation", getName);
    console.log("searchStudio", getName);
    let params = queryParamas;

    getName?.value ? (params.name = `${getName?.value}`) : delete params.name;
    setqueryParamas({ ...params });
    // if (getName.id) {
    // 	const response = await axios(
    // 		'GET',
    // 		CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
    // 			API.END_POINTS.TC_BYID +
    // 			`?` +
    // 			`tc_id=${getName.id}`,
    // 		{},
    // 		{},
    // 		{}
    // 	).then((response) => {
    // 		// console.log('TrainingCenter', response?.data?.data?.rows);
    // 		setApiResponse(response?.data?.data?.rows);
    // 		setloading(false);
    // 		return response.data;
    // 	});
    // }
  };

  const apiCall = async () => {
    console.log("apiCall:::::::::::::");
    const name_Key = "name" in queryParamas;
    if (name_Key) {
      delete queryParamas.offset;
    }
    queryParamas.limit = 12;
    setloading(true);
    const response = await axios(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.TCADMIN_ENDPOINT,
      queryParamas,
      {},
      {}
    ).then((response) => {
      console.log("tcAdminDetail", response?.data?.data?.rows);
      setApiResponse(response?.data?.data?.rows);
      setloading(false);
      setPageCount(() => Math.ceil(response?.data?.data?.count / limit));

      return response.data;
    });
  };

  const exportapiCall = async () => {
    console.log("apiCall:::::::::::::");
    let qp = queryParamas;
    const from_date_Key = "from_date" in qp;
    const end_date_Key = "end_date" in qp;
    const name_Key = "name" in qp;
    const studio_id_Key = "studio_id" in qp;

    if (from_date_Key || end_date_Key || name_Key || studio_id_Key) {
      delete qp.limit;
      delete qp.offset;
    }
    //delete qp.limit;
    const response = await axios(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.TCADMIN_ENDPOINT,
      qp,
      {},
      {}
    ).then((response) => {
      console.log("tcAdminDetail", response?.data?.data?.rows);
      setexportApiResponse(response?.data?.data?.rows);
      setloading(false);
      setPageCount(() => Math.ceil(response?.data?.data?.count / limit));

      return response.data;
    });
  };

  const singleDelete = (list) => {
    setSingleDeleteId(list);
    setShowSingleModal(true);
  };

  const multipleDeleteList = (list) => {
    if (multipleDelete.length < 1) {
      toast.error("Select Records To Delete", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else {
      setShowModal(true);
    }
  };

  const searchStudio = async (StudioName) => {
    console.log("searchStudio", StudioName);
    let params = queryParamas;

    StudioName ? (params.name = `${StudioName}`) : delete params.name;
    setqueryParamas({ ...params });
  };

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 50,
    height: 25,
    padding: 0,
    borderRadius: 30,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 20,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(15px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(25px)",
        color: "#0C0D16",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: theme.palette.mode === "dark" ? "white" : "white",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 20,
      height: 20,
      borderRadius: 30,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === "dark" ? "rgba(0,0,0,.25)" : "rgba(0,0,0,.25)",
      boxSizing: "border-box",
    },
  }));

  const onPageClickhandler = (e, data) => {
    setqueryParamas((prevState) => ({
      ...prevState,
      offset: Math.ceil((data - 1) * limit),
    }));
  };

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const exportFile = () => {
    dispatch(setemptyDeleteList());
    dispatch(setemptycheckedList());
  };

  // useEffect(() => {
  // 	apiCall();
  // 	console.log('tcAdminDetail:::::', tcAdminDetail);
  // }, []);

  const datefilter = async (range) => {
    let startDate = range[0];
    let endDate = range[1];
    let params = queryParamas;

    // let startDate = range[0];
    // let endDate = range[1];
    // let params = queryParamas;
    // console.log('startDate', startDate);
    // console.log('endDate', endDate);
    range[0]
      ? (params.from_date = `${moment(startDate).format("YYYY-MM-DD")}`)
      : delete params.from_date;

    range[1]
      ? (params.end_date = `${moment(endDate).format("YYYY-MM-DD")}`)
      : delete params.end_date;
    // if (range[0]) {
    // 	params.from_date = `${moment(startDate).format('YYYY-MM-DD')}`;
    // }

    // if (range[1]) {
    // 	params.end_date = `${moment(endDate).format('YYYY-MM-DD')}`;
    // }
    setqueryParamas({ ...params });
    console.log("datefilter", queryParamas);
    // let startDate = range[0];
    // let endDate = range[1];
    // console.log('startDate', startDate);
    // console.log('endDate', endDate);
    // if (startDate && endDate) {
    // 	const response = await axios(
    // 		'GET',
    // 		CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
    // 			API.END_POINTS.TCADMIN_ENDPOINT +
    // 			`?` +
    // 			`from_date=${startDate}` +
    // 			`&` +
    // 			`end_date=${endDate}`,
    // 		{},
    // 		{},
    // 		{}
    // 	).then((response) => {
    // 		// console.log('TrainingCenter', response?.data?.data?.rows);
    // 		setApiResponse(response?.data?.data?.rows);
    // 		setloading(false);
    // 		console.log('dateResponse', apiResponse);
    // 		return response.data;
    // 	});
    // }
  };

  const columns = [
    { displayName: "Name", id: "name" },
    { displayName: "Date", id: "created_at" },
    {
      displayName: "Average Session Length",
      id: "avg_sesseion_length",
    },
    {
      displayName: "Total Students",
      id: "total_students",
    },
    {
      displayName: "Average no. of disconnect",
      id: "average_no_of_disconnect",
    },
    {
      displayName: " Total Scheduled Training ",
      id: "total_scheduled_trainning",
    },
  ];

  const datas =
    multipleChecked.length > 0 ? multipleChecked : exportapiResponse;
  const clearButton = () => {
    if (userRole == "SUPER_ADMIN") {
      document.getElementById("TcAdminCLearFilter").click();
      document.getElementById("TcAdminDropCLearFilter").click();
    }
    document.getElementById("TcAdminCLearDate").click();
    setShowFilter(!showFilter);
  };

  const getAllTC = async () => {
    const response = await axios(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.STUDIO_LIST +
        `?` +
        `is_active=true`,
      {},
      {},
      {}
    )
      .then((response) => {
        console.log("response", response?.data?.data?.rows);
        const list = response?.data?.data?.rows?.map((value) => ({
          id: value?.id,
          value: value?.studio_name,
          label: value?.studio_name,
        }));
        setAllTC(list);
        console.log("allTC0", allTC);
      })
      .catch((err) => {
        console.log("err::", err);
        toast.error("LOCATION NOT FOUND", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  useEffect(() => {
    if (loadApi) {
      apiCall();
      exportapiCall();
    } else {
      setloadApi(true);
    }
  }, [queryParamas]);
  useEffect(() => {
    if (loginData?.role_code === "STUDIO_ADMIN") {
      setqueryParamas({ ...queryParamas, studio_id: loginData?.studio_id });
    } else {
    }
  }, []);

  useEffect(() => {
    if (userRole === "SUPER_ADMIN") {
      getAllTC();
      getAllInst();
    }
  }, []);

  useEffect(() => {
    if (window.innerWidth < 770) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [window.innerWidth]);
  const closemodal = () => {
    setShowModal(false);
    setShowSingleModal(false);
  };

  const deleteList = async () => {
    const response = await axios(
      "DELETE",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.DELETETCADMIN +
        `?` +
        `ids=[${multipleDelete.map((value) => `"${value}"`)}]`,
      {},
      {},
      {}
    )
      .then((response) => {
        toast.success("Record Deleted", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        apiCall();
        setShowModal(false);
        setFlag(!flag);
        dispatch(setemptyDeleteList());
        dispatch(setemptycheckedList());
        return response.data;
      })
      .catch(() => {
        setShowModal(false);
        toast.error("RECORDS NOT DELETED", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  const singleDeleteModal = async () => {
    const response = await axios(
      "DELETE",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.DELETETCADMIN +
        `?` +
        `ids=["${singleDeleteId}"]`,
      {},
      {},
      {}
    )
      .then((response) => {
        toast.success("Record Deleted", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        apiCall();
        setShowSingleModal(false);

        setFlag(!flag);
        return response.data;
      })
      .catch(() => {
        setShowSingleModal(false);
        toast.error("RECORDS NOT DELETED", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  return (
    <div id="tcAdminDIV">
      {showModal ? (
        <DeleteAlert closeModal={closemodal} deleteList={deleteList} />
      ) : (
        ""
      )}
      {showSingleModal ? (
        <SingleDelete
          closeModal={closemodal}
          singleDeleteModal={singleDeleteModal}
        />
      ) : (
        ""
      )}
      <div className="scrollContainer">
        <Stack direction="row" spacing={"20%"}>
          <SubHeading
            title={"Training Center Admin"}
            checked={checked}
            switchHandler={switchHandler}
            gridview={switchHandler}
            searchChange={searchStudio}
            multipleDeleteList={multipleDeleteList}
            columns={columns}
            datas={datas}
            exportFile={exportFile}
            redirect={APP_ROUTES.ADD_TC_ADMIN}
            setShowFilter={setShowFilter}
            showFilter={showFilter}
            exportfileTitle={"TCAdmin_Master_Data"}
            addText={"Add TC Admin"}
          />
        </Stack>

        <div style={{ display: showFilter ? "contents" : "none" }}>
          <Stack
            direction="row"
            className="lowerFilterContain"
            justifyContent={"center"}
            marginTop="1%"
          >
            <Grid container>
              <Grid item flexGrow={0.2} xs={12} sm={12} md={5} lg={4}>
                <DateRangePicker
                  getdateRange={datefilter}
                  clearID={"TcAdminCLearDate"}
                  // startDateProps={lastday}
                  // endDateProps={currentDate}
                />
              </Grid>
              {userRole === "SUPER_ADMIN"}
              <Grid
                container
                direction={"row"}
                flexGrow={0.2}
                xs={12}
                sm={12}
                md={7}
                lg={8}
              >
                <Grid
                  item
                  // flexGrow={0.3}
                  xs={6}
                  sm={6}
                  md={6}
                  lg={6}
                  // marginTop={{ xs: '1%', sm: '1%', md: '2%' }}
                >
                  {userRole === "STUDIO_ADMIN" ? (
                    ""
                  ) : (
                    <Dropdown
                      clearable
                      options={allTC}
                      selectDropDown={dropdownSelect}
                      clearID={"TcAdminCLearFilter"}
                      placeholder="Training Center "
                    />
                  )}
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  lg={6}
                  className="marginTopInstrut"
                >
                  <Button
                    className="fs-4"
                    value="Clear Filter"
                    role="clearFilter"
                    onClick={() => {
                      clearButton();
                    }}
                  >
                    Clear Filter
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Stack>
        </div>

        <>
          {/* {tcAdminDetail ? (
					<InstructorDetails res={apiResponse} ondeleteClick={singleDelete} />
				) : ( */}
          <Box sx={{ bgcolor: "#232135", height: "100vh" }}>
            {checked ? (
              <>
                {loading ? (
                  <MultiLine_Spinner />
                ) : (
                  <Stack direction="row" width="100%" flexWrap="wrap">
                    <TCCardView
                      res={apiResponse}
                      lgWidth={"4"}
                      ondeleteClick={singleDelete}
                    />
                  </Stack>
                )}
              </>
            ) : (
              <>
                {loading ? (
                  <MultiLine_Spinner />
                ) : (
                  <Stack>
                    {apiResponse?.length > 0 ? (
                      apiResponse?.map((res) => {
                        return (
                          <Stack
                            onClick={() => {
                              // setShowDetails(true);
                            }}
                          >
                            <TCList res={res} ondeleteClick={singleDelete} />
                          </Stack>
                        );
                      })
                    ) : (
                      <Stack className="NO_RECORD_FOUND">No Record Found</Stack>
                    )}
                  </Stack>
                )}
              </>
            )}
          </Box>
          {/* )} */}
          {/* <Stack alignItems="end" marginTop={'-1%'}>
					<Pagination count={pageCount} onChange={onPageClickhandler} />
				</Stack> */}
        </>
      </div>
      <Stack alignItems="end" marginTop={"0.5%"}>
        <Pagination
          count={pageCount}
          onChange={onPageClickhandler}
          disabled={pageCount === 1}
        />
      </Stack>
    </div>
  );
};

export default TCAdmin;
